import { defineStore } from 'pinia';

import {
  login as loginAPI,
  logout as logoutAPI,
  verifyOtp as verifyOtpAPI,
  getUser as getUserAPI,
  updateUser as updateUserAPI,
  resetUserPassword as resetUserPasswordAPI,
} from '@/api/auth';
import { getToken, removeToken, setToken } from '@/utils/cookies';

import { usePushNotificationStore } from '@/store/push-notification';

export const useAuthStore = defineStore('auth', {
  state: () => ({
    user: null,
    twoFactor: null,
    token: getToken(),
    credentials: false,
  }),

  actions: {
    async login(credentials, router) {
      return await loginAPI(credentials).then(({ tfa, temporary_token }) => {
        this.$patch({
          twoFactor: tfa,
          credentials: true,
        });

        localStorage.removeItem('loginAttempts');
        setToken(temporary_token, 300, true);

        router.push({ name: 'OTP' });
      });
    },

    async verifyOtp(otp, router) {
      return await verifyOtpAPI({ otp }).then(({ token, expires_in, user }) => {
        this.$patch({
          token: token,
          user: user,
        });

        removeToken(true);
        setToken(token, expires_in);

        // Initialize push notifications after successful login
        const pushStore = usePushNotificationStore();
        pushStore.initializeAfterLogin().catch((err) => {
          console.log('Push notification initialization failed:', err.message);
        });

        router.push({ name: 'Home' });
      });
    },

    async logout(router) {
      await logoutAPI().finally(() => {
        removeToken();

        this.$patch({
          user: null,
          token: null,
          twoFactor: null,
          credentials: false,
        });

        router.push({ name: 'Login' });
      });
    },

    async getUser() {
      await getUserAPI()
        .then((response) => {
          this.$patch({
            user: response,
          });

          // Initialize push notifications when user data is loaded
          const pushStore = usePushNotificationStore();
          pushStore.initializeAfterLogin().catch((err) => {
            console.log(
              'Push notification initialization failed:',
              err.message
            );
          });
        })
        .catch(() => {
          removeToken();
          this.$patch({
            user: null,
            token: null,
            twoFactor: null,
          });
          window.location.origin = '/login';
        });
    },
    async updateUser(updates) {
      try {
        const response = await updateUserAPI(updates);
        this.$patch((state) => {
          if (state.user) {
            Object.assign(state.user, updates);
          }
        });
        return response;
      } catch (error) {
        // console.error('Error updating user:', error);
        throw error;
      }
    },
    async resetUserPassword(updates) {
      try {
        const response = await resetUserPasswordAPI(updates);
        this.$patch((state) => {
          if (state.user) {
            Object.assign(state.user, updates);
          }
        });
        return response;
      } catch (error) {
        // console.error('Error updating user:', error);
        throw error;
      }
    },
  },
});
